import React from "react"

import {
    Grid,
    Typography
} from "@mui/material"

import { Trans } from "@lingui/macro"


import { ActionTimeline } from "models"

interface TimelineCardProps {
    showState: boolean
    timeline: ActionTimeline
}
interface TimelineCardState {
}
export class TimelineCard extends React.Component<TimelineCardProps, TimelineCardState> {
    private content: string = ""

    componentDidMount() {
        this.content = ""
    }

    render() {
        return (
            <Grid container mt={1}>
                <Grid item xs>
                    <Typography sx={{ fontSize: 14, fontWeight: "bold", }}>
                        <Trans id={"enums.action-timeline-type." + this.props.timeline.type}>
                        </Trans>
                    </Typography>
                </Grid>
                {/*<Grid item xs="auto" alignItems="flex-end">*/}
                {/*    {this.props.showState &&*/}
                {/*        <Button*/}
                {/*            type="button"*/}
                {/*            variant="text"*/}
                {/*            disableFocusRipple*/}
                {/*            disableRipple*/}
                {/*            disableTouchRipple*/}
                {/*            startIcon={<Icon path={mdiAvTimer} size={1} />}*/}
                {/*            sx={{ textTransform: "none", color: "text.primary" }}>*/}
                {/*            <Trans id="actions.state">Stato</Trans>*/}
                {/*        </Button>*/}
                {/*    }*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12}>*/}
                {/*    <Box sx={{bgcolor: "#e6ecff"}} mt={2} p={2}>*/}
                {/*        <Typography sx={{fontWeight: "bold", fontSize: 13}}>*/}
                {/*            Note:*/}
                {/*        </Typography>*/}
                {/*        <Typography sx={{fontSize: 13}}>*/}
                {/*            {this.content !== "" ? this.content : "Nessun messaggio trovato"}*/}
                {/*        </Typography>*/}
                {/*    </Box>*/}
                {/*</Grid>*/}
            </Grid>
        )
    }
}
